import { useEffect } from "react";
import SolarCalculator from "../components/SolarCalculator/SolarCalculator";
import "./styles/Calculator.css";

const PAGE_TITLE =
  "Solar Savings Calculator (2026) — Free, No Signup | Your Energy Guru";

export default function Calculator() {
  // index.html ships a static <title>, which wins over React's hoisted one
  // on this page — set it imperatively instead.
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <meta
        name="description"
        content="Estimate your solar system size, cost, payback period, and 25-year savings in seconds. Honest 2026 math — no federal tax credit assumed, real net-metering caveats, no signup required."
      />
      <link rel="canonical" href="https://yourenergyguru.com/calculator" />
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <SolarCalculator />
      </div>
    </div>
  );
}
